import { ChangeEvent, SetStateAction, useCallback, useEffect, useState } from 'react'
import { CargoItemInterface, PointItemInterface } from '../../../../../../types/interfaces'
import { gMapsAddressHandler } from '../../../../../../utils/functions/gMapsAddressHandler'
import { useLocation } from 'react-router-dom'

export const useGMapInput = (
  fieldName: 'city' | 'address',
  setData: React.Dispatch<SetStateAction<PointItemInterface[]>>,
  data: PointItemInterface[],
  el: PointItemInterface,
  index: number,
  intercity: boolean,
  addresses: boolean,
  topData: CargoItemInterface,
  setTopData: React.Dispatch<SetStateAction<CargoItemInterface>>,
) => {
  const [autocomplete] = useState<{ value: google.maps.places.Autocomplete | {} }>({ value: {} })
  const location = useLocation()

  const onPlaceChanged = useCallback(
    (e: Event) => {
      var place =
        autocomplete.value instanceof google.maps.places.Autocomplete &&
        autocomplete.value.getPlace()
      if (place && place.geometry && place.geometry.location && place.address_components) {
        let tempData = [...data]
        tempData[index][fieldName].value = gMapsAddressHandler(fieldName, place).text
        tempData[index][fieldName].latitude = place.geometry.location.lat().toString()
        tempData[index][fieldName].longitude = place.geometry.location.lng().toString()
        tempData[index][fieldName].isDirty = true

        setTopData((prev) => ({ ...prev, route: undefined }))

        if (fieldName === 'address' && place.address_components) {
          tempData[index].city.value = gMapsAddressHandler('city', place).text
        }

        setData(tempData)
      }
    },
    [data, index, autocomplete.value, setData],
  )

  const initAutocomplete = useCallback(
    (id: string, value?: string) => {
      const htmlEl: HTMLInputElement | HTMLElement | null = document.getElementById(id)
      //@ts-ignore
      if (htmlEl && value) htmlEl.value = value
      if (htmlEl && htmlEl instanceof HTMLInputElement)
        autocomplete.value = new google.maps.places.Autocomplete(htmlEl, {
          bounds:
            !intercity &&
            data.length === 1 &&
            location.pathname.split('/')[1] !== 'transport' &&
            data[0].address.latitude &&
            data[0].address.longitude
              ? {
                  north: Number(data[0].address.latitude) + 0.2,
                  south: Number(data[0].address.latitude) - 0.2,
                  east: Number(data[0].address.longitude) + 0.2,
                  west: Number(data[0].address.longitude) - 0.2,
                }
              : undefined,
          types: intercity && !addresses ? ['locality'] : ['geocode'],
          componentRestrictions: { country: [`RU`] },
          fields: ['geometry', 'address_components'],
        })

      if (autocomplete.value instanceof google.maps.places.Autocomplete)
        autocomplete.value.addListener('place_changed', onPlaceChanged)

      //@ts-ignore
      if (htmlEl && htmlEl.value) {
        htmlEl.blur()
        setTimeout(() => {
          htmlEl.focus()
        }, 100)
      }
    },
    [autocomplete, onPlaceChanged, addresses, data, intercity, location.pathname],
  )

  useEffect(() => {
    const regex = new RegExp('[0-9]')
    if (
      (fieldName === 'city' &&
        // data[index][fieldName].value.length > 0 &&
        Object.keys(autocomplete.value).length === 0) ||
      (fieldName === 'address' &&
        regex.test(el[fieldName].value) &&
        data[index][fieldName].value.length > 4 &&
        Object.keys(autocomplete.value).length === 0)
    ) {
      initAutocomplete(`${fieldName}_${el.id}`, el[fieldName].value)
      // const htmlEl: HTMLInputElement | null = document.querySelector(`${fieldName}_${el.id}`)
      // if (htmlEl) {
      //   htmlEl.blur()
      //   setTimeout(() => {
      //     htmlEl.focus()
      //   }, 100)
      // }
    }
    return () => {
      const htmlEl: HTMLElement | null = document.getElementById(`${fieldName}_${el.id}`)
      if (htmlEl) htmlEl.removeEventListener('place_changed', onPlaceChanged)
    }
  }, [data, fieldName, index, el])

  const dataReset = (e: ChangeEvent<HTMLInputElement>) => {
    let tempData = [...data]
    tempData[index][fieldName].value = e.target.value
    tempData[index][fieldName].latitude = undefined
    tempData[index][fieldName].longitude = undefined
    tempData[index][fieldName].isDirty = true
    setData(tempData)
  }

  useEffect(() => {
    autocomplete.value = {}
  }, [data[index].sequence])

  return {
    dataReset,
  }
}
